import { useState, useEffect } from 'react';

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: "https://readdy.ai/api/search-image?query=Elegant%20mature%20woman%20carefully%20selecting%20fresh%20colorful%20fruits%20at%20vibrant%20produce%20market%20stand%20with%20abundant%20variety%20of%20apples%20oranges%20and%20seasonal%20fruits%20displayed%20in%20wooden%20crates%2C%20warm%20natural%20lighting%20creating%20welcoming%20atmosphere%20in%20traditional%20grocery%20store%20setting&width=1920&height=1080&seq=hero-woman-fruits-003&orientation=landscape",
      title: "Frutas Selecionadas",
      subtitle: "Frescor e qualidade"
    },
    {
      image: "https://readdy.ai/api/search-image?query=Fresh%20organic%20green%20leafy%20vegetables%20including%20lettuce%20kale%20spinach%20and%20mixed%20greens%20arranged%20beautifully%20on%20rustic%20wooden%20surface%20with%20soft%20natural%20lighting%20emphasizing%20vibrant%20colors%20and%20premium%20quality%20of%20farm%20fresh%20produce&width=1920&height=1080&seq=hero-vegetables-001&orientation=landscape",
      title: "Verduras Frescas",
      subtitle: "Vegetais orgânicos selecionados"
    },
    {
      image: "https://readdy.ai/api/search-image?query=Premium%20quality%20raw%20beef%20steaks%20and%20noble%20meat%20cuts%20for%20barbecue%20displayed%20on%20elegant%20dark%20surface%20with%20professional%20lighting%20highlighting%20marbling%20texture%20and%20freshness%20of%20high-end%20butcher%20shop%20products&width=1920&height=1080&seq=hero-meat-002&orientation=landscape",
      title: "Carnes Nobres",
      subtitle: "Cortes premium para churrasco"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="absolute inset-0">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>
      ))}

      <div className="relative h-full flex items-center justify-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center w-full">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight px-4">
            {slides[currentSlide].title}
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-6 sm:mb-8 max-w-3xl mx-auto px-4">
            {slides[currentSlide].subtitle}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12 sm:mb-16 px-4">
            <a
              href="https://pedido.anota.ai/loja/rancho-das-verduras-2"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto bg-[#9bc53d] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-white hover:text-[#2d5016] transition-all duration-300 shadow-2xl hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Fazer Pedido Online
            </a>
            <button
              onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
              className="w-full sm:w-auto bg-white/10 backdrop-blur-sm text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-white hover:text-[#2d5016] transition-all duration-300 border-2 border-white whitespace-nowrap cursor-pointer"
            >
              Conheça-nos
            </button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-8 max-w-4xl mx-auto px-4">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 sm:p-6 border border-white/20">
              <div className="text-3xl sm:text-4xl font-bold text-white mb-2">15+</div>
              <div className="text-sm sm:text-base text-white/80">Anos de Experiência</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 sm:p-6 border border-white/20">
              <div className="text-3xl sm:text-4xl font-bold text-white mb-2">2</div>
              <div className="text-sm sm:text-base text-white/80">Lojas em Paulínia</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 sm:p-6 border border-white/20">
              <div className="text-3xl sm:text-4xl font-bold text-white mb-2">100%</div>
              <div className="text-sm sm:text-base text-white/80">Produtos Frescos</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-2 sm:gap-3 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide ? 'bg-white w-6 sm:w-8' : 'bg-white/50'
            }`}
            aria-label={`Ir para slide ${index + 1}`}
          ></button>
        ))}
      </div>
    </section>
  );
}
